<template>
    <div>
        <el-form :model="comnSvcRequire" ref="comnSvcInfo">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">名称</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="title" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input type="text" v-model="comnSvcRequire.title" placeholder="请输入名称"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">服务类型</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="servcTypeId" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-select v-model="comnSvcRequire.servcTypeId" @change="servcTypeChange">
                                <el-option v-for="item in servcTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">允许抢单</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="grabIssueAllowed">
                            <el-radio-group v-model="comnSvcRequire.grabIssueAllowed">
                                <el-radio :label="true">是</el-radio>
                                <el-radio :label="false">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>
                <!--<div class="form-group center" v-if="comnSvcRequire.grabIssueAllowed">-->
                <!--<div class="form-label">-->
                <!--<label class="required">抢单默认价(元)</label>-->
                <!--</div>-->
                <!--<div class="form-value width-2x">-->
                <!--<el-form-item prop="grabPrice" :rules="{validator: checkGrabPrice, trigger: 'blur'}">-->
                <!--<el-input type="text" v-model="comnSvcRequire.grabPrice"></el-input>-->
                <!--</el-form-item>-->
                <!--</div>-->
                <!--</div>-->
                <div class="form-group center">
                    <div class="form-label">
                        <label>描述</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="desc">
                            <el-input type="textarea" :rows="4" v-model="comnSvcRequire.desc" placeholder="请输入描述"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="content-caption dashed">
            <span>适用机构</span>
            <a class="swb-btn-link" @click="selectShop()">选择</a>
        </div>
        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th style="text-align: left">机构名称</th>
                <th width="120">机构级别</th>
                <th width="150">包含下级机构</th>
                <th width="80">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr v-if="appliedShopList.length > 0" v-for="(item,index) in appliedShopList" class="row">
                <td style="text-align: left">
                    <span>{{item.comName}}</span>
                </td>
                <td>
                    <span>{{getTransComLevel(item.comLevel)}}</span>
                </td>
                <td style="text-align: center;">
                    <el-checkbox v-model="item.includeSubComs" v-if="item.comLevel <= 4"/>
                </td>
                <td>
                    <span class="swb-btn swb-btn-link" @click="removeShop(index)">移除</span>
                </td>
            </tr>
            <tr v-if="appliedShopList.length <= 0">
                <td colspan="4" style="text-align: center; line-height: 40px;">
                    <span>暂无数据...</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { transComLevel } from '../orgStruct/struct-comn'
    import { openRetailerComTreeMultiSelectDlg } from '../orgStruct/selectDlg'

    import shopComnReqApi from '../../api/shopComnReq'

    export default {
        name: 'swb-comn-require-save',
        desc: '常规服务需求-保存',
        props: ['id'],
        data: function () {
            return {
                comnSvcRequire: {
                    grabIssueAllowed: false
                },
                appliedShopList: [],
                servcTypeList: getEnumList("servcType")
            }
        },
        created: function () {
            if(!Utils.isNoB(this.id)) {
                this.getComnSvcRequireInfo();
            }
        },
        methods: {
            getTransComLevel: function (level) {
                return transComLevel(level);
            },
            checkNull: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            // 获取常规服务需求
            getComnSvcRequireInfo: function () {
                let self = this;
                let msgBoxDlg = MsgBox.loading();
                shopComnReqApi.getComnSvcRequireById(this.id, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let comnSvcRequire = result.data;
                        comnSvcRequire.grabPrice = parseFloat(comnSvcRequire.grabPrice || 0).toFixed(2);
                        self.comnSvcRequire = Utils.merge({}, comnSvcRequire);
                        //
                        self.getComnSvcRequireAppliedShopList(comnSvcRequire.id);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取适用门店
            getComnSvcRequireAppliedShopList: function (requireId) {
                let self = this;
                let msgBoxDlg = MsgBox.loading();
                shopComnReqApi.getShopComnRepairByRequireId({requireId: requireId}, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        //
                        self.appliedShopList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 服务类型变化事件
            servcTypeChange: function () {
                let comnSvcRequire = this.comnSvcRequire || {};
                let servcTypeInfo = getEnumInfoWith('servcType', 'value', comnSvcRequire.servcTypeId);
                if(!Utils.isNoB(servcTypeInfo)) {
                    comnSvcRequire.servcTypeName = servcTypeInfo.text;
                } else {
                    comnSvcRequire.servcTypeName = null;
                }
                this.comnSvcRequire = Utils.merge({}, comnSvcRequire);
                this.$refs['comnSvcInfo'].validate(function (valid) {
                });
            },
            selectShop(){
                let self = this;
                let dlgConfig = {
                    checkStrictly: true,
                    showCheckboxLevel1: true,
                    showCheckboxLevel2: true,
                    showCheckboxLevel3: true,
                    bizDepart: false
                };
                let displayDataList = this.appliedShopList;
                openRetailerComTreeMultiSelectDlg(dlgConfig, displayDataList, function (result) {
                    if(result.type == "info") {
                        let comList = result.data || [];
                        if(comList.length > 0) {
                            for(let i = 0; i < comList.length; i++) {
                                comList[i].includeSubComs = false;
                            }
                        }
                        self.appliedShopList = Utils.merge([], comList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            removeShop(index){
                this.appliedShopList.removeAt(index);
            },
            getDlgResult(){
                let self = this;
                let comnSvcRequire = Utils.merge({}, this.comnSvcRequire);
                let result = {};
                this.$refs['comnSvcInfo'].validate(function (valid) {
                    if(valid) {
                        comnSvcRequire.comList = self.appliedShopList || [];
                        //
                        result.data = comnSvcRequire;
                        result.type = 'info';
                    } else {
                        let msg = '';
                        if(Utils.isNoB(comnSvcRequire.title)) {
                            msg = "请输入名称";
                        }
                        if(Utils.isNoB(comnSvcRequire.servcTypeId)) {
                            if(Utils.isNoB(msg)) {
                                msg = "请选择服务类型";
                            } else {
                                msg += "；请选择服务类型";
                            }
                        }
                        if(Utils.isTrue(comnSvcRequire.grabIssueAllowed) && Utils.isNoB(comnSvcRequire.grabPrice)) {
                            if(Utils.isNoB(msg)) {
                                msg = "请输入抢单默认价";
                            } else {
                                msg += "；请输入抢单默认价";
                            }
                        } else if(Utils.isTrue(comnSvcRequire.grabIssueAllowed) && !Utils.isMoneyStr(comnSvcRequire.grabPrice)) {
                            if(Utils.isNoB(msg)) {
                                msg = "请输入正确的金额";
                            } else {
                                msg += "；请输入正确的金额";
                            }
                        }
                        if(!Utils.isNoB(msg)) {
                            msg += "！";
                        }
                        //
                        result.type = 'warn';
                        result.message = msg;
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shopComnReq/ComnSvcRequireSave.vue